import React from 'react'
import { Stack } from '@mui/material'
import UITextHeadlineLarge from '../../../ui/UIText/UITextHeadlineLarge'
import UIButtonMediumHollow from '../../../ui/UIButton/UIButtonMediumHollow'
import UIButtonMedium from '../../../ui/UIButton/UIButtonMedium'
import UIModal from '../../../ui/UIModal/UIModal'

const RecoverModal = ({ data, open, setOpen, handleSubmit, isLoading }) => {
  return (
    <UIModal wrapperStyles={{ width: '700px' }} open={open} setOpen={setOpen}>
      <Stack gap="30px">
        <UITextHeadlineLarge>
          Are you sure you want to recover customer <br /> &quot;
          <span style={{ fontWeight: 700 }}>{data?.name}</span>&quot;?
        </UITextHeadlineLarge>
        <Stack direction="row" gap="10px">
          <UIButtonMediumHollow fullWidth onClick={() => setOpen(false)}>
            Cancel
          </UIButtonMediumHollow>
          <UIButtonMedium disabled={isLoading} fullWidth onClick={() => handleSubmit()}>
            Recover
          </UIButtonMedium>
        </Stack>
      </Stack>
    </UIModal>
  )
}

export default RecoverModal
